import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { Button } from "@similarweb/ui-components";

export const GAButton = styled(Button)`
    padding-left: 36px;
`;

export const GAIcon = styled(SWReactIcons)`
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
`;

export const GAContainer = styled.div`
    margin-left: auto;
    position: relative;
`;
